<template>
  <div>
    <nav-breadcrumb :menu="[{label: '还款管理'}, {label: '还款详情'}]"/>
    <element>
      <panel label="还款信息">
        <form-build-component
          :form-data="cashJournalDetail"
          :form-columns="cashJournalColumns"
          class="formTable"
        />
      </panel>
      <panel label="提款信息">
        <data-table-component
          :table-data="repaymentData"
          :columns="repaymentColumns"
          :is-pagination-show="false"
        />
      </panel>
      <el-dialog :visible.sync="dialogVisible" title="还款金额详情">
        <form-build-component
          :form-data="rexData"
          :form-columns="rexColumns"
          class="formTable"
        />
      </el-dialog>
    </element>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import Panel from "../../../components/Panel";
  import FormBuildComponent from "../../../components/FormBuild";
  import moment from 'moment'
  import DataTableComponent from "../../../components/DataTable";
  import {formatMoney} from "../../../filters/CommonFilters";
  import Status2CN from '../../../filters/Status2CN'

  export default {
    name: "FinancingRepayDetail",
    components: {DataTableComponent, FormBuildComponent, Panel},
    data() {
      return {
        cj__reference : this.$route.query['cj.reference'],
        dialogVisible: false,
        cashJournalDetail: {},
        cashJournalColumns: [
          {
            label: '流水号',
            field: 'cj__reference'
          },
          {
            label: '还款方式',
            field: 'cj__channel',
            formatter: function (r,v) {
              return Status2CN(v)
            }
          },
          {
            label: '交易时间',
            field: 'cj__postingDate',
            formatter: function (r,v) {
              return moment(v).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label: '客户姓名',
            field: 'u__customerName'
          },
          {
            label: '还款账户',
            field: 'cj__outboundAccountDesc',
            span: 24
          },
          {
            label: '收款账户',
            field: 'cj__inboundAccountDesc',
            span: 24
          },
          {
            label: '还款金额',
            field: 'cj__postingAmount',
            formatter:  (r,v)=> {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '状态',
            unit: '还款完成'
          },
          {
            label: '备注',
            field: 'cj__remarks',
            span: 24
          },
        ],
        repaymentData: {},
        repaymentColumns: [
          {
            label: '贷款编号',
            field: 'fi__transactionNo'
          },
          {
            label: '客户姓名',
            field: 'i__contactPerson'
          },
          {
            label: '手机号',
            field: 'i__contactTelNo'
          },
          {
            label: '贷款用途',
            field: 'fi__intendedUse'
          },
          {
            label: '贷款金额',
            field: 'fi__totalAmount',
            formatter:  (r,c,v)=> {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '贷款期限',
            formatter: function (r,c,v) {
              return r.fi__startDate + '~' + r.fi__endDate
            }
          },
          /*{
            label: '本次还款本金',
            field: 'rex__principalAmount',
            formatter:  (r,v)=> {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '本次还款利息',
            field: 'rex__interestAmount',
            formatter:  (r,v)=> {
              return formatMoney(v)+'元'
            }
          },*/
          {
            label: '本次还款金额',
            field: 're__totalAmount',
            formatter:  (r,c,v)=> {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '操作',
            opts: [
              {
                label: '明细',
                component: 'el-button',
                size: 'mini',
                class: 'el-icon-more',
                type: 'primary',
                clickHandler: (index, row)=>{
                  this.dialogVisible = true
                  this.rexData = row
                }
              }
            ]
          }
        ],
        rexData: {},
        rexColumns: [
          {
            label: '本金',
            field: 'rex__principalAmount',
            formatter:  (r,v)=> {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '利息',
            field: 'rex__interestAmount',
            formatter:  (r,v)=> {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '服务费用',
            field: 'rex__lendingFeeAmount',
            formatter:  (r,v)=> {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '其他费用',
            field: 'rex__otherAmount',
            formatter:  (r,v)=> {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '逾期罚息',
            field: 'rex__overdueFine',
            formatter:  (r,v)=> {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '提前还款违约金',
            field: 'rex__penalyAmount',
            formatter:  (r,v)=> {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '减免费用(-)',
            field: 'rex__deductionAmount',
            span: 24,
            formatter:  (r,v)=> {
              return formatMoney(v)+'元'
            }
          },
          {
            label: '总金额',
            field: 're__totalAmount',
            span:24,
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            }
          }
        ]
      }
    },
    mounted() {
      this.getFinanceRepaymentDetail(this.cj__reference)
    },
    methods: {
      getFinanceRepaymentDetail: function (reference) {
        xhr.getCustomerCashJournalList(
          {
            'xlist.search.cj.reference': reference,
            'xlist.search.cj.reference.op': 'eq'
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.cashJournalDetail = res.data.data.shift();
                if (this.cashJournalDetail.cj__reference ) {
                  this.getCustomerRepaymentList(this.cashJournalDetail.cj__reference)
                }
              }
            }catch (e) {

            }
          }
        )
      },
      getCustomerRepaymentList: function (reference) {
        xhr.getCustomerRepaymentList(
          {
            'xlist.search.cj.reference' : reference,
            'xlist.search.cj.reference.op' : 'eq',
            pageSize: 9999
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                this.repaymentData = res.data
              }
            }catch (e) {

            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/FinancingRepayDetail.vue